import React from 'react';
import {
  shape,
  string
} from 'prop-types';
import classNames from 'classnames/bind';
import { Typography } from '@one-thd/sui-atomic-components';

export const StoreHours = ({ hours }) => {
  const cx = classNames.bind();
  const convertTo12HrFormat = (hhmm) => {
    if (hhmm && hhmm.split(':').length && hhmm.split(':').length === 2) {
      const hoursStr = hhmm.split(':')[0];
      const minStr = hhmm.split(':')[1];

      const hoursInt = parseInt(hoursStr, 10);
      if (hoursInt === 0) {
        return `12${':'}${minStr}am`;
      }
      if (hoursInt < 12) {
        return `${hoursStr}${':'}${minStr}am`;
      }
      if (hoursInt === 12) {
        return `${hoursStr}${':'}${minStr}pm`;
      }

      const pmHoursString = (hoursInt - 12).toString();
      return `${pmHoursString}${':'}${minStr}pm`;
    }
    return hhmm;
  };

  const {
    monday,
    tuesday,
    wednesday,
    thursday,
    friday,
    saturday,
    sunday
  } = hours || {};

  const mon = { name: 'Monday', ...monday };
  const tue = { name: 'Tuesday', ...tuesday };
  const wed = { name: 'Wednesday', ...wednesday };
  const thu = { name: 'Thursday', ...thursday };
  const fri = { name: 'Friday', ...friday };
  const sat = { name: 'Saturday', ...saturday };
  const sun = { name: 'Sunday', ...sunday };

  const days = [mon, tue, wed, thu, fri, sat, sun];

  const normalDays = [];
  const irregularDays = [];

  days.slice(0, days.length - 1).forEach((day) => {
    const hasIrregularHours = day?.open && day?.close && (
      day?.open !== mon?.open || day?.close !== mon?.close
    );
    if (hasIrregularHours) {
      irregularDays.push(day);
    } else if (irregularDays.length === 0) {
      normalDays.push(day);
    } else {
      irregularDays.push(day);
    }
  });

  const getOpenCloseHours = (day) => {
    if (day?.open === day?.close) {
      return 'Closed';
    }
    return `${convertTo12HrFormat(day?.open)} - ${convertTo12HrFormat(day?.close)}`;
  };

  const getOpenCloseLabel = (day, day2) => {
    if (day2) {
      return `${day?.name.substring(0, 3)}-${day2?.name.substring(0, 3)}: `;
    }
    return `${day?.name.substring(0, 3)}: `;
  };

  const labelStyles = cx('sui-font-capitalize', { 'sui-font-bold': true });

  const getOpenCloseBlock = (day, day2) => {
    return (
      <div className="sui-overflow-hidden sui-text-ellipsis sui-whitespace-nowrap" key={day?.storeId}>
        <Typography height="tight">
          <span className={labelStyles}>
            {getOpenCloseLabel(day, day2)}
          </span>
          {getOpenCloseHours(day)}
        </Typography>
      </div>
    );
  };

  return (
    <div data-testid="store-pod-hours" data-component="StorePodHours">
      {normalDays.length === 1 && getOpenCloseBlock(mon)}
      {normalDays.length > 1 && getOpenCloseBlock((normalDays[0]), normalDays.slice(-1)[0])}
      {irregularDays.map((day) => getOpenCloseBlock(day))}
      {getOpenCloseBlock(sun)}
    </div>
  );
};

const openCloseShape = shape({
  open: string,
  close: string
});

StoreHours.propTypes = {
  hours: shape({
    monday: openCloseShape,
    tuesday: openCloseShape,
    wednesday: openCloseShape,
    thursday: openCloseShape,
    friday: openCloseShape,
    saturday: openCloseShape,
    sunday: openCloseShape
  })
};

StoreHours.defaultProps = {
  hours: {}
};